import { dataPackageUpload } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPackageUpload = /*#__PURE__*/createIcon(dataPackageUpload)
export default IconPackageUpload
